import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-play-circle-line text-primary-500 mr-2"></i>
              热门视频
            </h2>
            <p className="text-foreground-500 text-sm">精选最受关注的吃瓜视频内容</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {mediaItems.map((item, idx) => (
              <a
                key={idx}
                href="#media"
                className="group block bg-background-50 rounded-xl overflow-hidden cursor-pointer no-underline transition-colors hover:bg-background-200"
              >
                <div className="relative aspect-video bg-background-200 overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded">
                    {item.duration}
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="w-12 h-12 flex items-center justify-center bg-primary-500/90 text-background-50 rounded-full text-xl group-hover:bg-primary-600 transition-colors">
                      <i className="ri-play-fill"></i>
                    </span>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="px-2 py-0.5 bg-primary-100 text-primary-600 text-xs rounded-full font-medium">{item.tag}</span>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.views}次播放</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}